<template>
  <div v-loading="loading" v-bind:element-loading-text="$t('message.Desperately_loading')" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-container>
      <el-header>
        <head_page :head_page_type=false ref="head_page"></head_page>
      </el-header>
      <el-main>
        <div id='choose_city'>
          <head_menu :has-back=true @go-back-click="goBack" >
            <template #title>
              <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:5px;font-size: 20px;">
                <!-- {{chosen_city=='first'?'Global':chosen_city}} -->
              </div>
            </template>
            <template  #button-group-right>
              <el-button-group>
                <el-button v-if = "isDirector" @click="dialogFormVisible = true" class="hidden-md-and-down">
                  {{$t('message.Setting')}}
                </el-button>
                <el-dialog :visible.sync="dialogFormVisible" >
                
                  <div style = "text-align: left;">
                    <el-row style="color: rgb(37, 74, 110);font-weight: 900;font-size: larger;padding-bottom: 5px;">
                      <el-col :span = '10'>Status </el-col>
                      <el-col :span = '2'> &nbsp;</el-col>
                      <el-col :span = '12'>Number of days</el-col>
                    
                    </el-row>
                    <el-row>
                      <el-col :span = '10'> 
                        <div data-v-66c4dacb="" class="white" style="cursor: pointer; margin: 10px 0px; width: 100px;     font-size: 14px; text-align: center;"> Draft </div>
                      </el-col>
                      <el-col :span = '2'>&nbsp;</el-col>
                      <el-col :span = '12'> <el-input  v-model="day_draft" ></el-input></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span = '10'> 
                        <div data-v-66c4dacb="" class="discussion" style="cursor: pointer; margin: 10px 0px; width: 100px;     font-size: 14px; text-align: center;"> Sent </div>
                      </el-col>
                      <el-col :span = '2'>&nbsp;</el-col>
                      <el-col :span = '12'> <el-input v-model="day_sent"></el-input></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span = '10'> 
                        <div data-v-66c4dacb="" class="gray" style="cursor: pointer; margin: 10px 0px; width: 100px;     font-size: 14px; text-align: center;"> Discussion </div>
                      </el-col>
                      <el-col :span = '2'>&nbsp;</el-col>
                      <el-col :span = '12'> <el-input v-model="day_discussion"></el-input></el-col>
                    </el-row>

                  </div>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">{{$t('message.Cancel')}}</el-button>
                    <el-button type="primary" @click="updateStatusDay"  >{{$t('message.OK')}}</el-button>
                  </div> 
              
                </el-dialog>
              </el-button-group>
            </template>
          </head_menu>
          <!--
          <div style="text-align: left;">
            <el-row>
              <el-col :span="24" style="background-color: #F0F0EE;">
                <el-button-group>
                  <el-button icon="el-icon-d-arrow-left" @click="goBack" style="background-color: #f3f3f4;"></el-button>
                  <el-button icon="el-icon-s-home" @click="goHome" style="background-color: #e9e9ea;"></el-button>
                </el-button-group>
              </el-col>
            </el-row>
          </div>
          -->
          <div style="background-color: #f8f8f9;">
            <!-- data table for big screen-->
            <el-row class="hidden-xs-only">
              <el-tabs type="card" v-model="activeName" @tab-click="handleTabChange">
                <el-tab-pane :label="$t('message.Proposal')" name="proposal" ></el-tab-pane>
                <el-tab-pane :label="$t('message.Appliance')" name="appliance"></el-tab-pane>
              </el-tabs>

              <div v-if="activeName == 'proposal'">
              
                <el-table :data="tableData" style="width: 100%"
                :header-cell-style="rowClass"
                :row-class-name="tableRowClassName"
                :row-key="getRowKeys"
                :expand-row-keys="expandsProposal"
                @expand-change="expandSelect"
                tooltip-effect="light"
                >
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-form label-position="left" inline class="demo-table-expand">
                        <el-row>
                          <el-col :span="18">
                            <el-form-item label="Impressions">
                              <span>{{ props.row.impressions }}</span>
                            </el-form-item>
                            <el-form-item label="Total Bus Line">
                              <span>{{ props.row.total_bus_line }}</span>
                            </el-form-item>
                            <el-form-item label="Total Media Budget">
                              <span>{{ props.row.total_media_budget }}</span>
                            </el-form-item>
                            <el-form-item label="Apply Discount">
                              <span>{{ props.row.discount }}</span>
                            </el-form-item>
                            <el-form-item label="Discounted Media Budget">
                              <span>{{ props.row.discounted_media_budget }}</span>
                            </el-form-item>
                            <el-form-item label="Package Name">
                              <span>{{ props.row.package_name }}</span>
                            </el-form-item>
                          </el-col>

                          <el-col :span="6" style="text-align: right;">
                            <div>
                              
                            </div>
                          </el-col>
                        </el-row>
                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('message.Created_at')" prop="createdAt" width = "160">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip :label="$t('message.Client_name')" prop="clientName" width = "140">
                    <template slot-scope="scope" slot="header">
                      <span :class="{ 'highlight': clientKeywordHighlight }">{{$t('message.Client_name')}}</span>
                      <span class="el-table__column-filter-trigger"></span>
                      <el-popover placement="bottom" trigger="click" transition="el-zoom-in-top" visible-arrow=false
                        style="padding: 0;" v-model="clientKeywordVisible">
                        <div class="proposal-history-table-filter">
                          <div class="proposal-history-table-filter__content">
                            <div class="sub-title">{{$t('message.Search_client')}}</div>
                            <input class="search-input" type="text" :placeholder="$t('message.Please_enter_keyword')" v-model="clientKeyword" />
                          </div>
                          <div class="proposal-history-table-filter__bottom">
                            <button @click="clientFilterHandler" 
                              :class="{ 'is-disabled': clientKeyword.length === 0 }"
                              :disabled="clientKeyword.length === 0" >{{$t('message.Filter')}}</button>
                            <button @click="clientResetHandler">{{$t('message.Reset')}}</button>
                          </div>
                        </div>
                        <span  :class="{ 'highlight': true }" style="cursor: pointer; margin-left: 5px; margin-top: -15px;" slot="reference"><i class="el-icon-search"></i></span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip :label="$t('message.City')" prop="city"  width = "100" >
                    <template slot-scope="scope">
                      <span v-if = "scope.row.city.includes(',')">
                        {{scope.row.city}}                        
                      </span>
                      <span v-else>
                        {{$t('message.'+scope.row.city)}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('message.Campaign_start')" prop="campaignStart">
                  </el-table-column>
                  <el-table-column :label="$t('message.Campaign_end')" prop="campaignEnd">
                  </el-table-column>
                  <el-table-column :label="$t('message.Created_by')" prop="createdBy">
                    <template slot-scope="scope" slot="header">
                      <span :class="{ 'highlight': creatorKeywordHighlight }">{{$t('message.Created_by')}}</span>
                      <span class="el-table__column-filter-trigger"></span>
                      <el-popover placement="bottom" trigger="click" transition="el-zoom-in-top" visible-arrow=false
                        style="padding: 0;" v-model="creatorKeywordVisible">
                        <div class="proposal-history-table-filter">
                          <div class="proposal-history-table-filter__content">
                            <div class="sub-title">{{$t('message.Search_creator')}}</div>
                            <input class="search-input" :placeholder="$t('message.Please_enter_keyword')" v-model="creatorKeyword" />                          
                          </div>
                          <div class="proposal-history-table-filter__bottom">
                            <button @click="creatorFilterHandler" 
                              :class="{ 'is-disabled': creatorKeyword.length === 0 }"
                              :disabled="creatorKeyword.length === 0" >{{$t('message.Filter')}}</button>
                            <button @click="creatorResetHandler">{{$t('message.Reset')}}</button>
                          </div>
                        </div>
                        <span :class="{ 'highlight': true }"  style="cursor: pointer; margin-left: 10px;" slot="reference"><i class="el-icon-search" style="transform: scale(0.75);"></i></span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('message.Team')" prop="team">
                    <template slot-scope="scope">
                      {{$t('message.'+scope.row.team)}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="status" min-width=80
                    > <!--:filters="statusFilter" filter-placement="bottom"  :filter-method="statusFilterHandler"-->
                    
                    <template slot-scope="scope" slot="header">
                      <span :class="{ 'highlight': statusArrayHighlight }">{{$t('message.Status')}}</span>
                      <span class="el-table__column-filter-trigger"></span>
                      <el-popover placement="bottom" trigger="click" transition="el-zoom-in-top" visible-arrow=false
                        style="padding: 0;" v-model="statusArrayVisible">
                        <div class="proposal-history-table-filter">
                          <div class="proposal-history-table-filter__content">                        
                            <el-checkbox-group v-model="statusArray" style="margin-top: 5px;">
                              <el-checkbox label="1">{{$t('message.Draft')}}</el-checkbox>
                              <el-checkbox label="2">{{$t('message.Discussion')}}</el-checkbox>
                              <el-checkbox label="3">{{$t('message.Sent')}}</el-checkbox>
                              <el-checkbox label="4">{{$t('message.Win')}}</el-checkbox>
                              <el-checkbox label="5">{{$t('message.Fail')}}</el-checkbox>
                              <el-checkbox label="6">{{$t('message.Cancelled')}}</el-checkbox>
                              <!--<el-checkbox label="7">{{$t('message.Archive')}}</el-checkbox>-->
                            </el-checkbox-group>
                          </div>
                          <div class="proposal-history-table-filter__bottom">
                            <button @click="statusFilterHandler" 
                              :class="{ 'is-disabled': statusArray.length === 0 }"
                              :disabled="statusArray.length === 0" >{{$t('message.Filter')}}</button>
                            <button @click="statusResetHandler">{{$t('message.Reset')}}</button>
                          </div>
                        </div>
                        <span :class="{ 'highlight': true }"  style="cursor: pointer; margin-left: 10px;" slot="reference"><i class="el-icon-search" style="transform: scale(0.75);"></i></span>
                      </el-popover>
                    </template>
                    
                    <template slot-scope="scope1"> 
                      <div>
                        <el-select v-if="scope1.row.isChanged"
                          v-model="scope1.row.status"
                          @change="handleChange(scope1.row,scope1.$index)"
                          @blur="handleBlur(scope1.row,scope1.$index)"
                          >
                          <el-option 
                            v-for="item in scope1.row.status_options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.label">
                            <span style="float: left">{{ item.label }}</span>
                            <span>
                              <div class="circle" :class="{ white: (item.value == '1'), discussion: (item.value == '2'),
                              gray: (item.value == '3'), win: (item.value == '4'), black: (item.value == '5'),
                              darkgrey: (item.value == '6'), green: (item.value == '7')
                              }"></div>
                            </span>
                          </el-option>
                        </el-select>
                      </div>
                      <div>
                        <div style="cursor:pointer; margin:20px 0; width: 100px; text-align: center;"
                              v-if="!scope1.row.isChanged"
                              @click="handleSelect(scope1.row,scope1.$index)"
                              :class="{ white:(scope1.row.status == $t('message.Draft')), discussion: (scope1.row.status == $t('message.Discussion')),
                              gray: (scope1.row.status == $t('message.Sent')), win: (scope1.row.status == $t('message.Win')), black: (scope1.row.status == $t('message.Fail')),
                              darkgrey: (scope1.row.status == $t('message.Cancelled')), green: (scope1.row.status == $t('message.Archive'))}">
                              
                              {{scope1.row.status}}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('message.Operation')" width="220">
                    <template slot-scope="scope">
                      <div>
                        <el-button size="mini" v-if="!scope.row.is_shared && !scope.row.package_id" @click="handleEdit(scope.$index, scope.row)">{{$t('message.Edit')}}</el-button>
                        <el-button size="mini" @click="viewAction(scope.row)">{{$t('message.Files')}}</el-button>
                        <el-button v-if="share_proposal" size="mini" @click="share(scope.row)">{{$t('message.Share')}}</el-button>
                      </div>
                      
                    </template>
                  </el-table-column>

                </el-table>
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 50]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalSize">
                </el-pagination>
              </div>

              <div v-if="activeName == 'appliance'">
                <el-table :data="processTableData" style="width: 100%"
                :row-class-name="processRowClassName"
                :row-key="getRowKeys"
                :header-cell-style="rowClass"
                :expand-row-keys="expandsAppliance"
                @expand-change="expendProcess">  
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-row v-loading="props.row.loading" style="margin: 20px 0;">
                        <el-col :col="22" :offset="1">
                          <el-descriptions v-if="props.row.process_detail">
                            <el-descriptions-item :label="$t('message.Discount_Type')">{{isMediaPricingMode(props.row) ? $t('message.Media_Discount') : $t('message.Proposal_Discount')}}</el-descriptions-item>
                            <el-descriptions-item :label="$t('message.Viewed_Impression')">{{props.row.process_detail.data_map.total_audience_impressions}}</el-descriptions-item>
                            <el-descriptions-item :label="$t('message.Viewed_Impression(Audience)_1')">{{props.row.process_detail.data_map.total_solution_impressions}}</el-descriptions-item>

                            <el-descriptions-item :label="$t('message.Reduced_Rate')">
                              <span>{{isMediaPricingMode(props.row) ? props.row.process_detail.data_map.media_discount : props.row.process_detail.data_map.proposal_discount}}% / </span>
                              <span style="color: red">({{props.row.process_detail.discount_limit}}%)</span>
                            </el-descriptions-item>
                            <el-descriptions-item :label="$t('message.Proposal_CPM')">{{props.row.process_detail.data_map.discount_proposal_CPM}}</el-descriptions-item>
                            <el-descriptions-item :label="$t('message.Proposal_CPM_cluster_1')">{{props.row.process_detail.data_map.discount_adjusted_proposal_CPM}}</el-descriptions-item>
                            <el-descriptions-item :label="$t('message.Proposal_Cost')">{{props.row.process_detail.data_map.proposal_discount_cost.toLocaleString()}}</el-descriptions-item>
                          </el-descriptions>
                        </el-col>
                      </el-row>
                      <el-row v-if="props.row.process_type == 'pricing'" v-loading="props.row.loading" style="margin: 20px 0;">
                        <!-- Card 1 -->
                        <el-col :span="6" :offset="1">
                          <el-card class="box-card" >
                            <div slot="header" class="clearfix">
                              <span>{{$t('message.Applied')}}</span>
                            </div>
                            <div>
                              <el-descriptions class="margin-top" :column="1" border>
                                <el-descriptions-item>
                                  <template slot="label">
                                    {{$t('message.Applicant')}}
                                  </template>
                                  {{props.row.createdBy}}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                  <template slot="label">
                                    {{$t('message.Created_at')}}
                                  </template>
                                  {{props.row.createdAt}}
                                </el-descriptions-item>
                              </el-descriptions>
                            </div>
                          </el-card>
                        </el-col>
                        <el-col :span="2" class="process_next_icon" v-if="props.row.process_status != 2">
                          <i class="el-icon-d-arrow-right"></i>
                        </el-col>
                        
                        <!-- Card 2 -->
                        <el-col :span="6" v-if="props.row.process_status != 2">
                          <el-card class="box-card" >
                            <div slot="header" class="clearfix">
                              <span>{{getStatusSd(props.row.process_status)}}</span>
                            </div>
                            <div>
                              <el-descriptions class="margin-top" :column="1" border>
                                <el-descriptions-item>
                                  <template slot="label">
                                    {{$t('message.Sales_Director')}}
                                  </template>
                                  {{props.row.updated_by_sd}}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                  <template slot="label">
                                    {{$t('message.Updated_at')}}
                                  </template>
                                  {{props.row.updated_at_sd}}
                                </el-descriptions-item>
                                <el-descriptions-item v-if="props.row.comment_sd && props.row.comment_sd.length>0">
                                  <template slot="label">
                                    {{$t('message.Comment')}}
                                  </template>
                                  {{props.row.comment_sd}}
                                </el-descriptions-item>
                              </el-descriptions>
                            </div>
                          </el-card>
                        </el-col>
                        <el-col :span="2" class="process_next_icon" v-if="props.row.process_status >= 6 || props.row.process_status == 2">
                          <i class="el-icon-d-arrow-right"></i>
                        </el-col>
                        
                        <!-- Card 3 -->
                        <el-col :span="6">
                          <el-card class="box-card" v-if="props.row.process_status >= 6 || props.row.process_status == 2" >
                            <div slot="header" class="clearfix">
                              <span>{{getStatusSales(props.row.process_status)}}</span>
                            </div>
                            <div>
                              <el-descriptions class="margin-top" :column="1" border>
                                <el-descriptions-item>
                                  <template slot="label">
                                    {{$t('message.Applicant')}}
                                  </template>
                                  {{props.row.updatedBy}}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                  <template slot="label">
                                    {{$t('message.Updated_at')}}
                                  </template>
                                  {{props.row.updatedAt}}
                                </el-descriptions-item>
                              </el-descriptions>
                            </div>
                          </el-card>
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('message.Created_at')" prop="createdAt" width="180">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip :label="$t('message.Client_name')" prop="clientName">
                  </el-table-column>
                  <el-table-column :label="$t('message.City')" prop="city">
                    <template slot-scope="scope">
                      {{$t('message.'+scope.row.city)}}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('message.Campaign_start')" prop="campaignStart">
                  </el-table-column>
                  <el-table-column :label="$t('message.Campaign_end')" prop="campaignEnd">
                  </el-table-column>
                  <el-table-column :label="$t('message.Team')" prop="team">
                    <template slot-scope="scope">
                      {{$t('message.'+scope.row.team)}}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('message.Status')" prop="status" width="160">
                    <template slot-scope="scope1"> 
                      <div>
                        <div style="margin:20px 0; width: 100px; text-align: center;"
                              :class="{ white:(scope1.row.status == $t('message.Pending')), darkgrey: (scope1.row.status == $t('message.Cancelled') || scope1.row.status == $t('message.Refused')),
                              green: (scope1.row.status == $t('message.Approved_by_Director') || scope1.row.status == $t('message.Accepted')), win: (scope1.row.status == $t('message.Changed_by_Director')), orange: (scope1.row.status == $t('message.Refused_by_Director')),
                              }">
                              
                              {{scope1.row.status}}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('message.Operation')" width="250">
                    <template slot-scope="scope">
                      <div>
                        <el-button v-if="enableReviewProcess(scope.row)" size="mini" @click="viewProcess(scope.row)">{{$t('message.Review')}}</el-button>
                        <el-button v-if="enableCancelProcess(scope.row)" size="mini" @click="cancelProcess(scope.row)">{{$t('message.Cancel')}}</el-button>
                        <el-button v-if="enableEditProcess(scope.row)" size="mini" @click="editProcess(scope.row)">{{$t('message.Edit')}}</el-button>
                      </div>
                      
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-row>
            <!-- data table for small screen-->
            <el-row class="hidden-sm-and-up" style="background-color: white">
              <!--
                <el-row v-for="(ele, index) in tableData" :key="index" style="font-size: 8px; background-color: #FFFFFF; text-align: left; word-break: break-word;">
                  <el-row>
                    <el-col :span="8">
                      {{$t('message.Client_name')}}: {{ele.clientName}}
                    </el-col>
                    <el-col :span="8">
                      <el-select v-if="ele.isChanged"
                        style="font-size: 8px"
                        v-model="ele.status"
                        @change="handleChange(ele, index)"
                        @blur="handleBlur(ele, index)"
                        >
                        <el-option 
                          v-for="item in ele.zhou"
                          :key="item.value"
                          :label="item.label"
                          :value="item.label">
                          <span style="float: left">{{ item.label }}</span>
                          <span>
                            <div class="circle" :class="{ white: (item.value == '1'), blue: (item.value == '2'),
                            orange: (item.value == '3'), pink: (item.value == '4'), black: (item.value == '5')
                            }"></div>
                          </span>
                        </el-option>
                      </el-select>
                      <div>
                        <span style="cursor:pointer; margin:0 10px; padding:0 5px"
                              v-if="!ele.isChanged"
                              @click="handleSelect(ele, index)"
                              :class="{ white:(ele.status == $t('message.Draft')), blue: (ele.status == $t('message.Discussion')),
                              orange: (ele.status == $t('message.Sent')), pink: (ele.status == $t('message.Win')), black: (ele.status == $t('message.Fail')),
                              }">
                              {{ele.status}}
                        </span>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      {{$t('message.Client_name')}}: {{ele.clientName}}
                    </el-col>
                  </el-row>
                </el-row>
              -->
              <el-table :data="tableData" style="width: 100%; margin-top: 10px; border-top: thin solid #DCDFE6;" 
                :row-class-name="tableRowClassName"
              >
                <el-table-column type="expand" width="20">
                  <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                      <el-row style="margin-left: 10px">
                        <el-col :span="24" style="font-size:10px">
                          <el-form-item label="Created At">
                            <span>{{ props.row.createdAt }}</span>
                          </el-form-item>
                          <el-form-item label="City">
                            <span>{{ props.row.city }}</span>
                          </el-form-item>
                          <el-form-item label="Campaign Start">
                            <span>{{ props.row.campaignStart }}</span>
                          </el-form-item>
                          <el-form-item label="Campaign End">
                            <span>{{ props.row.campaignEnd }}</span>
                          </el-form-item>
                          <el-form-item label="Team">
                            <span>{{ $t('message.'+props.row.team) }}</span>
                          </el-form-item>
                          <el-form-item label="">
                            <span></span>
                          </el-form-item>
                          <el-divider></el-divider>

                          <el-form-item label="Impressions">
                            <span>{{ props.row.impressions }}</span>
                          </el-form-item>
                          <el-form-item label="Total Bus Line">
                            <span>{{ props.row.total_bus_line }}</span>
                          </el-form-item>
                          <el-form-item label="Total Media Budget">
                            <span>{{ props.row.total_media_budget }}</span>
                          </el-form-item>
                          <el-form-item label="Apply Discount">
                            <span>{{ props.row.discount }}</span>
                          </el-form-item>
                          <el-form-item label="Discounted Media Budget">
                            <span>{{ props.row.discounted_media_budget }}</span>
                          </el-form-item>
                          <el-form-item label="Package Name">
                            <span>{{ props.row.package_name }}</span>
                          </el-form-item>
                        </el-col>

                        <el-col :span="6" style="text-align: right;">
                          <div>
                            
                          </div>
                        </el-col>
                      </el-row>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('message.Client_name')" prop="clientName" min-width="100%">
                </el-table-column>
                <el-table-column :label="$t('message.Status')" prop="status" min-width=110>
                  <template slot-scope="scope1">
                    <div>
                      <el-select v-if="scope1.row.isChanged"
                        size="small"
                        v-model="scope1.row.status"
                        @change="handleChange(scope1.row,scope1.$index)"
                        @blur="handleBlur(scope1.row,scope1.$index)"
                        >
                        <el-option 
                          v-for="item in scope1.row.status_options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.label">
                          <span style="float: left; font-size: 10px;">{{ item.label }}</span>
                          <span>
                            <div class="circle" :class="{ white: (item.value == '1'), discussion: (item.value == '2'),
                            gray: (item.value == '3'), win: (item.value == '4'), black: (item.value == '5'),
                            darkgrey: (item.value == '6'), green: (item.value == '7')
                            }"></div>
                          </span>
                        </el-option>
                      </el-select>
                    </div>
                    <div>
                      <div style="cursor:pointer;margin:10px 0; width: 100px; text-align: center;"
                            v-if="!scope1.row.isChanged"
                            @click="handleSelect(scope1.row,scope1.$index)"
                            :class="{ white:(scope1.row.status == $t('message.Draft')), discussion: (scope1.row.status == $t('message.Discussion')),
                            gray: (scope1.row.status == $t('message.Sent')), win: (scope1.row.status == $t('message.Win')), black: (scope1.row.status == $t('message.Fail')),
                            darkgrey: (scope1.row.status == $t('message.Cancelled')), green: (scope1.row.status == $t('message.Archive'))}">
                            
                            {{scope1.row.status}}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('message.Operation')" width="250">
                  <template slot-scope="scope">
                    <div>
                      <el-button size="mini" v-if="!scope.row.is_shared && !scope.row.package_id" @click="handleEdit(scope.$index, scope.row)">{{$t('message.Edit')}}</el-button>
                      <el-button size="mini" @click="viewAction(scope.row)">{{$t('message.Files')}}</el-button>
                      <el-button v-if="share_proposal" size="mini" @click="share(scope.row)">{{$t('message.Share')}}</el-button>
                    </div>
                    
                  </template>
                </el-table-column>

              </el-table>
            </el-row>
          </div>
        </div>
        <el-dialog :title="$t('message.Share_the_proposal')" :visible.sync="shareFormVisible" :before-close="handleCloseDialog">
          <el-form class="hidden-sm-and-down">
            <el-form-item :label="$t('message.Share_with')" label-width="100px" >
              <el-select style="width:90%" v-model="selectedUser" value-key="user_id" :placeholder="$t('message.Please_select_the_users')" filterable>
                <el-option v-for="item in user_options" :key="item.user_id" :label="item.user_name" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          
          <el-col class="hidden-md-and-up" style="text-align: left; margin-bottom: 50px;">
            <p style="margin-left:5px">{{$t('message.Share_with')}}</p>
            <el-select style="width:100%; margin-top: 10px;" v-model="selectedUser" value-key="user_id" :placeholder="$t('message.Please_select_the_users')" filterable>
              <el-option v-for="item in user_options" :key="item.user_id" :label="item.user_name" :value="item">
              </el-option>
            </el-select>
          </el-col>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog()">{{$t('message.Cancel')}}</el-button>
            <el-button type="primary" @click="handleConfirmDialog()" :disabled="!selectedUser">{{$t('message.Confirm')}}</el-button>
          </div>
        </el-dialog>
      </el-main>
    </el-container>

  </div>

</template>

<script>
  import head_page from './components/head_page.vue';
  import head_menu from "./components/head_menu.vue";
  import axios from 'axios';
  import _global from './components/global.vue';
  export default {
    name: 'choose_city',
    data() {
      return {
        dialogFormVisible:false,
        isDirector: false,
        day_draft:'',
        day_sent:'',
        day_discussion:'',
        tableDataCommercial: [],
        loading: false,
        client_name: '',
        client_logo_image: '',
        value: '',
        tableData: [],
        processTableData:[],
        reportParam:'',
        media_format_options : [],
        rank_options : [],
        audience_info : [],
        gender_options : [],
        age_options : [],
        spend_power_options : [],
        interest_options : [],
        showColor: false,
        status_options: [{
          value: '1',
          label: this.$t('message.Draft')
        }, {
          value: '2',
          label: this.$t('message.Discussion')
        }, {
          value: '3',
          label: this.$t('message.Sent')
        }, {
          value: '4',
          label: this.$t('message.Win')
        }, {
          value: '5',
          label: this.$t('message.Fail')
        }, {
          value: '6',
          label: this.$t('message.Cancelled')
        }, /*{
          value: '7',
          label: this.$t('message.Archive')
        }*/],
        process_status_options: [{
          value: '1',
          label: this.$t('message.Pending')
        }, {
          value: '2',
          label: this.$t('message.Cancelled')
        }, {
          value: '3',
          label: this.$t('message.Approved_by_Director')
        }, {
          value: '4',
          label: this.$t('message.Changed_by_Director')
        }, {
          value: '5',
          label: this.$t('message.Refused_by_Director')
        }, {
          value: '6',
          label: this.$t('message.Accepted')
        }, {
          value: '7',
          label: this.$t('message.Refused')
        }],
        share_proposal: false,
        shareFormVisible: false,
        selectedProposal: '',
        selectedUser: '',
        /*
        user_options: [
          {
            id: 6,
            name: "Gina King",
          },
          {
            id: 9,
            name: "Jasmine Hu",
          },
          {
            id: 10,
            name: "Lin Yang",
          },
          {
            id: 15,
            name: "Stephen Wong",
          },
        ]
        */
        user_options:[],
        currentPage: 1,
        pageSize: 10,
        totalSize: 0,
        clientKeyword: "",
        clientKeywordVisible: false,
        clientKeywordHighlight: false,
        creatorKeyword: "",
        creatorKeywordVisible: false,
        creatorKeywordHighlight: false,
        statusArray: [],
        statusArrayVisible: false,
        statusArrayHighlight: false,
        expandsProposal: [],
        expandsAppliance: [],
        activeName: 'proposal',
      }
    },
    computed: {
      day: function() {
        let week;
        let date = new Date();
        if (date.getDay() == 0) week = this.$t('message.Sunday')
        if (date.getDay() == 1) week = this.$t('message.Monday')
        if (date.getDay() == 2) week = this.$t('message.Tuesday')
        if (date.getDay() == 3) week = this.$t('message.Wednesday')
        if (date.getDay() == 4) week = this.$t('message.Thursday')
        if (date.getDay() == 5) week = this.$t('message.Friday')
        if (date.getDay() == 6) week = this.$t('message.Saturday')
      
        return week;
      },
      date: function() {
        let date_org = new Date();
        let date_arr = String(date_org).split(" ");
        if (date_arr[1] == 'Jan') date_arr[1] = this.$t('message.Jan')
        if (date_arr[1] == 'Feb') date_arr[1] = this.$t('message.Feb')
        if (date_arr[1] == 'Mar') date_arr[1] = this.$t('message.Mar')
        if (date_arr[1] == 'Apr') date_arr[1] = this.$t('message.Apr')
        if (date_arr[1] == 'May') date_arr[1] = this.$t('message.May')
        if (date_arr[1] == 'Jun') date_arr[1] = this.$t('message.Jun')
        if (date_arr[1] == 'Jul') date_arr[1] = this.$t('message.Jul')
        if (date_arr[1] == 'Aug') date_arr[1] = this.$t('message.Aug')
        if (date_arr[1] == 'Sep') date_arr[1] = this.$t('message.Sep')
        if (date_arr[1] == 'Oct') date_arr[1] = this.$t('message.Oct')
        if (date_arr[1] == 'Nov') date_arr[1] = this.$t('message.Nov')
        if (date_arr[1] == 'Dec') date_arr[1] = this.$t('message.Dec')
        return date_arr[2] + ' ' + date_arr[1] + ' ' + date_arr[3];
      },
      localLang() {
        return this.$i18n.locale;
      },
      statusFilter() {
        return [{
            value: 1,
            text: this.$t('message.Draft'),
          }, {
            value: 2,
            text: this.$t('message.Discussion'),
          }, {
            value: 3,
            text: this.$t('message.Sent'),
          }, {
            value: 4,
            text: this.$t('message.Win'),
          }, {
            value: 5,
            text: this.$t('message.Fail'),
          }, {
            value: 6,
            text: this.$t('message.Cancelled'),
          }, /*{
            value: 7,
            text: this.$t('message.Archive'),
          }*/]
      }
    },
    components: {
      head_page,
      head_menu
    },
    created() {
      this.loading = true;
      if (JSON.parse(sessionStorage.getItem('User')) != null) {
        this.user = JSON.parse(sessionStorage.getItem('User')).split('.')[0].toUpperCase();
      }
      this.getStatusDay()
      window.addEventListener('click', event=>{
      });
    },
    mounted() {
      this.$refs.head_page.update_user_name();
      this.lang = JSON.parse(sessionStorage.getItem('lang'));
      let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
      if(UserAuthority.role == 'Management' || UserAuthority.role == "SalesDirector"){
        this.isDirector = true
      }
      this.$i18n.locale = this.lang;
      this.$refs.head_page.switchLang(this.lang);
      this.dialogFormVisible = false
      let tab = {}
      this.activeName = this.$route.query.type ? this.$route.query.type : "proposal"
      tab.name = this.activeName
      this.handleTabChange(tab)
    },
    updated() {},
    methods: {
      updateStatusDay(){
        let api_url = _global.serverSrc + '/update_status_day/?format=json&draft_day='+this.day_draft+'&sent_day='+this.day_sent+'&discussion_day='+this.day_discussion;
        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj).then(response => {
          this.$message({
            type: 'success',
            message: this.$t('message.Data_is_saved')
          });
          this.dialogFormVisible = false
        })
      },
      getStatusDay(){
        let api_url = _global.serverSrc + '/get_status_day/?format=json';
        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            this.day_draft = response.data.draft_number_day[0]
            this.day_sent = response.data.sent_number_day[0]
            this.day_discussion = response.data.discussion_number_day[0]
          })

      },
      handleBlur:function(val,index){
          setTimeout(
            ()=>{
              this.tableData[index].isChanged = false
            },300
          )
      },
      handleChange:function(val,index){
        if (val.isChanged == true){
          this.tableData[index].isChanged = false
          this.tableData[index].status = val.status
          //发送信息更改数据库
          let api_url = _global.serverSrc + '/status_check/?format=json';
          let obj = {}
          obj.reference_id = val.id
          obj.status_code = this.inverseProposalStatusChange(val.status)
          obj.email = JSON.parse(sessionStorage.getItem('User'))
          this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.status_check != null) {
              if (response.data.status_check[0].is_ok==1){
                this.$notify({
                  message: this.$t('message.The_data_is_successfully_uploaded'),
                  position: 'top-left'
                });
                
              }else{
                this.$notify({
                  message: this.$t('message.No_Authority'),
                  position: 'top-left'
                });
              }
              //this.$router.go(0)
              this.getHistoryData()
            }
          })
          .catch(e => {
          })
        
        }
        
      },
      handleSelect:function(val,index){
        if (val.isChanged == false){
          this.tableData[index].isChanged = true
        }
      },
      statusFilterHandler(value, row, column) {
        const property = column['property'];
        //return row[property] === value;
        return true;
      },
      goBack(){
        if (this.$route.query.back_url) {
          this.$router.push({
            path: this.$route.query.back_url
          })
        } 
        else {
          this.$router.back()
        }
      },
      viewAction(row){
        
        sessionStorage.removeItem('Data_History')
        sessionStorage.removeItem('tableDataCommercial')
        sessionStorage.removeItem('Data_Map')
        sessionStorage.removeItem('Data_Information')
        sessionStorage.removeItem('Data_Options')
        //1从数据库拿数据
        let api_url = _global.serverSrc + '/user_operation_history/?format=json';
        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        obj.id = row.id
        let package_id = row.package_id
        if (package_id && package_id != ''){
          this.$store.state.package.selected_package.selected_package_package_id = package_id
          this.$store.state.package.selected_package.client_name = row.clientName
          this.$router.push({
              path: '/package_board',
              query: {
                back_url: '/history'
              }
            });
        }else{
          if(row.city.includes(",")){
          this.$axios.post(_global.serverSrc + '/user_operation_history_crosscity/?format=json', obj)
          .then(response => {
           
            var param_json = JSON.parse(response.data.user_operation_history[0].report_param.replaceAll(`'`, `"`))
            let obj = {};
            var city=row.city.slice(0,row.city.length-1);
            var selectedCities =city.split(",");           
            let summaryTable = []
            let selectedMultiProposal = []
            
            summaryTable[0]={'city':'Nanjing','name':'Nanjing','line_qty': 0,'bus_line':[], 'body_qty': 0, 'impression': 0, 'impression_cluster': 0, 'price': 0,'cpm':0,'cpm_cluster':0,'data_audience':'','param_json':{'ifShowViewed':0}}
            summaryTable[1]={'city':'Wuhan','name':'Wuhan','line_qty': 0,'bus_line':[], 'body_qty': 0, 'impression': 0, 'impression_cluster': 0, 'price': 0,'cpm':0,'cpm_cluster':0,'data_audience':'','param_json':{'ifShowViewed':0}}
            summaryTable[2]={'city':'Shenzhen','name':'Shenzhen','line_qty': 0, 'bus_line':[],'body_qty': 0, 'impression': 0, 'impression_cluster': 0, 'price': 0,'cpm':0,'cpm_cluster':0,'data_audience':'','param_json':{'ifShowViewed':0}}
            summaryTable[3]={'city':'Chongqing','name':'Chongqing','line_qty': 0, 'body_qty': 0, 'bus_line':[],'impression': 0, 'impression_cluster': 0, 'price': 0,'cpm':0,'cpm_cluster':0,'data_audience':'','param_json':{'ifShowViewed':0}}
            summaryTable[4]={'city':'Chengdu','name':'Chengdu','line_qty': 0, 'body_qty': 0, 'bus_line':[],'impression': 0, 'impression_cluster': 0, 'price': 0,'cpm':0,'cpm_cluster':0,'data_audience':'','param_json':{'ifShowViewed':0}}
            
            param_json.forEach((item, index) => {
              let data = {}
              data.param_json = item;
              data.city = item.city
              data.body_qty = item.bus_body_qty
              data.bus_line = item.bus_line
              data.data_audience = item.data_audience
              data.data_audience.value_gender = this.changeDataToText(item.data_audience.value_gender, item.options.audience_options.gender_options)
              data.data_audience.value_age = this.changeDataToText(item.data_audience.value_age, item.options.audience_options.age_options)
              data.data_audience.value_spend_power = this.changeDataToText(item.data_audience.value_spend_power, item.options.audience_options.spend_power_options)
              data.data_audience.value_interest = this.changeDataToText(item.data_audience.value_interest, item.options.audience_options.interest_options)
              data.data_media = this.changeDataToText(item.data_media, item.options.media_rank_options.media_format_options)
              data.data_poi_ba_label_selection_list = this.changeDataToText_PoiSearch(item.poi_ba_label_selection_list)
              data.data_poi = this.changeDataToText_poi(item.data_poi)
              data.date =  new Date(item.date*1000).toISOString().split('T')[0]
              data.duration = item.duration
              data.impression = item.viewed_impression
              data.impression_cluster = item.viewed_impression_cluster
              data.line_qty = item.bus_line_qty
              data.name = item.city
              data.createdBy = item.created_by
              data.id = item.id
              if (item.data_map != ''){
                data.price = Number(item.data_map.proposal_discount_cost)
                data.cpm = (data.price/item.viewed_impression*1000).toFixed(2)
                data.cpm_cluster = (data.price/item.viewed_impression_cluster*1000).toFixed(2)
              } else {
                data.price = item.estimated_cost
                data.cpm = item.CPM
                data.cpm_cluster = item.CPM_cluster
               
              }  
              selectedMultiProposal.push(data)

              
            

            })
            for(let ele of selectedMultiProposal) {
             
        
              if(ele.city == 'Nanjing') {
              
                summaryTable[0].impression =  Number(summaryTable[0].impression) + Number(ele.param_json.viewed_impression)          
                summaryTable[0].impression_cluster =  Number(summaryTable[0].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
                summaryTable[0].price = Number(summaryTable[0].price) + Number(ele.param_json.price)
                summaryTable[0].cpm =  (summaryTable[0].price/summaryTable[0].impression*1000).toFixed(2)
                summaryTable[0].cpm_cluster = (summaryTable[0].price/summaryTable[0].impression_cluster*1000).toFixed(2)
                summaryTable[0].bus_line = this.MergeArrayAndFilter(summaryTable[0].bus_line,ele.bus_line)
                summaryTable[0].line_qty = summaryTable[0].bus_line.length
                summaryTable[0].body_qty = summaryTable[0].body_qty + ele.body_qty
                summaryTable[0].date = new Date(ele.param_json.date*1000).toISOString().split('T')[0]
                summaryTable[0].duration = ele.param_json.duration
                summaryTable[0].createdBy = ele.created_by
                summaryTable[0].id = ele.param_json.id
              

              } else if (ele.city == 'Wuhan') {
                summaryTable[1].impression =  Number(summaryTable[1].impression) + Number(ele.param_json.viewed_impression)          
                summaryTable[1].impression_cluster =  Number(summaryTable[1].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
                summaryTable[1].price = Number(summaryTable[1].price) + Number(ele.param_json.price)
                summaryTable[1].cpm =  (summaryTable[1].price/summaryTable[1].impression*1000).toFixed(2)
                summaryTable[1].cpm_cluster = (summaryTable[1].price/summaryTable[1].impression_cluster*1000).toFixed(2)
                summaryTable[1].bus_line = this.MergeArrayAndFilter(summaryTable[1].bus_line,ele.bus_line)
                summaryTable[1].line_qty = summaryTable[1].bus_line.length
                summaryTable[1].body_qty = summaryTable[1].body_qty + ele.body_qty
                summaryTable[1].date = new Date(ele.param_json.date*1000).toISOString().split('T')[0]
                summaryTable[1].duration = ele.param_json.duration
                summaryTable[1].createdBy = ele.created_by
                summaryTable[1].id = ele.param_json.id

              } else if (ele.city == 'Shenzhen') {
                summaryTable[2].impression =  Number(summaryTable[2].impression) + Number(ele.param_json.viewed_impression)          
                summaryTable[2].impression_cluster =  Number(summaryTable[2].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
                summaryTable[2].price = Number(summaryTable[2].price) + Number(ele.param_json.price)
                summaryTable[2].cpm =  (summaryTable[2].price/summaryTable[2].impression*1000).toFixed(2)
                summaryTable[2].cpm_cluster = (summaryTable[2].price/summaryTable[2].impression_cluster*1000).toFixed(2)
                summaryTable[2].bus_line = this.MergeArrayAndFilter(summaryTable[2].bus_line,ele.bus_line)
                summaryTable[2].line_qty = summaryTable[2].bus_line.length
                summaryTable[2].body_qty = summaryTable[2].body_qty + ele.body_qty
                summaryTable[2].date = new Date(ele.param_json.date*1000).toISOString().split('T')[0]
                summaryTable[2].duration = ele.param_json.duration
                summaryTable[2].createdBy = ele.created_by
                summaryTable[2].id = ele.param_json.id


              } else if (ele.city == 'Chongqing'){
                summaryTable[3].impression =  Number(summaryTable[3].impression) + Number(ele.param_json.viewed_impression)          
                summaryTable[3].impression_cluster =  Number(summaryTable[3].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
                summaryTable[3].price = Number(summaryTable[3].price) + Number(ele.param_json.price)
                summaryTable[3].cpm =  (summaryTable[3].price/summaryTable[3].impression*1000).toFixed(2)
                summaryTable[3].cpm_cluster = (summaryTable[3].price/summaryTable[3].impression_cluster*1000).toFixed(2)
                summaryTable[3].bus_line = this.MergeArrayAndFilter(summaryTable[3].bus_line,ele.bus_line)
                summaryTable[3].line_qty = summaryTable[3].bus_line.length
                summaryTable[3].body_qty = summaryTable[3].body_qty + ele.body_qty
                summaryTable[3].date = new Date(ele.param_json.date*1000).toISOString().split('T')[0]
                summaryTable[3].duration = ele.param_json.duration
                summaryTable[3].createdBy = ele.created_by
                summaryTable[3].id = ele.param_json.id

              } else if(ele.city == 'Chengdu') {
                summaryTable[4].impression =  Number(summaryTable[4].impression) + Number(ele.param_json.viewed_impression)          
                summaryTable[4].impression_cluster =  Number(summaryTable[4].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
                summaryTable[4].price = Number(summaryTable[4].price) + Number(ele.param_json.price)
                summaryTable[4].cpm =  (summaryTable[4].price/summaryTable[4].impression*1000).toFixed(2)
                summaryTable[4].cpm_cluster = (summaryTable[4].price/summaryTable[4].impression_cluster*1000).toFixed(2)
                summaryTable[4].bus_line = this.MergeArrayAndFilter(summaryTable[4].bus_line,ele.bus_line)
                summaryTable[4].line_qty = summaryTable[4].bus_line.length
                summaryTable[4].body_qty = summaryTable[4].body_qty + ele.body_qty
                summaryTable[4].date = new Date(ele.param_json.date*1000).toISOString().split('T')[0]
                summaryTable[4].duration = ele.param_json.duration
                summaryTable[4].createdBy = ele.created_by
                summaryTable[4].id = ele.param_json.id
              }
            }
            summaryTable = this.summaryTableInfo(summaryTable)
            obj.selectedCities = {...selectedCities}
            obj.selectedProposals = {}
            obj.proposalClientName = row.clientName
            obj.selectedProposals.summaryTable = summaryTable
            obj.selectedMultProposal = selectedMultiProposal
            sessionStorage.setItem("Cross_city", JSON.stringify(obj));
   
            this.$router.push({
              path: "/cross_city_board",
              query: {
                cities : selectedCities,
                canEdit: false
              }
            });
        })
        } else  {
          this.$axios.post(api_url, obj)
            .then(response => {
              if (response.data.user_operation_history != null) {
                let data = JSON.parse(response.data.user_operation_history[0].report_param)
                data.reference_id = row.id
                sessionStorage.setItem('Data_History', JSON.stringify(data))
                sessionStorage.setItem('Data_Map', JSON.stringify(data.data_map))
                this.$router.push({
                  path: '/board',
                  query: {
                    back_url: '/history'
                  }
                });
              }
            })
            .catch(e => {
            })
          }
        }
      },
      MergeArrayAndFilter(array, array1) {
          //将array数组转换成set对象
          let setObj = new Set(array)
          //循环数组array1，并将值通过add插入set对象中,此时重复数据并不会插入其中
          for(let i = 0; i < array1.length; i++) {
            setObj.add(array1[i]);
          }
          let newJson = []
          for(let item1 of setObj){  //循环json数组对象的内容
            let flag = true;  //建立标记，判断数据是否重复，true为不重复
            for(let item2 of newJson){  //循环新数组的内容
              if(item1.bus_id==item2.bus_id){ //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
                flag = false;
              }
            }
            if(flag){ //判断是否重复
              newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
            }
          }
          //使用Array.from()方法将set对象转换成数组，并使用sort()方法排序
          return Array.from(newJson).sort();
        },
      createDataMapFromHistory(dataHistory){
        
      },
      createOptionsFromHistory(dataHistory){
        sessionStorage.setItem('Data_Options', JSON.stringify(dataHistory.options))
      },
      viewProcess(row){
        sessionStorage.removeItem('Data_Process')
        sessionStorage.removeItem('Data_Information')
        if (!row.process_detail) {
          let api_url = _global.serverSrc + '/get_process_detail/';
          let obj = new Object();
          obj.email = JSON.parse(sessionStorage.getItem('User'))
          obj.reference_id = row.id
          this.$axios.post(api_url, obj)
            .then(response => {
              row.process_detail = response.data.process_detail
              this.createDataInformationFromHistory(row.process_detail)
              sessionStorage.setItem('Data_Process', JSON.stringify(row))
              this.$router.push({
                path: '/process_map',
                query: {
                  chosen_city: row.process_detail.city,
                  back_url: '/history'
                }
              });
            })
            .catch(error => {
              sessionStorage.setItem('Data_Process', row)
              this.$router.push({
                path: '/process_map',
                query: {
                  chosen_city: row.process_detail.city,
                  back_url: '/history'
                }
              });
            })
        }
        else {
          this.createDataInformationFromHistory(row.process_detail)
          sessionStorage.setItem('Data_Process', JSON.stringify(row))
          this.$router.push({
            path: '/process_map',
            query: {
              chosen_city: row.process_detail.city,
              back_url: '/history'
            }
          });
        }
      },
      cancelProcess(row){
        let api_url = _global.serverSrc + '/cancel_process/';
        let obj = new Object();
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        obj.reference_id = row.id
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.upload_check[0].is_ok == 1) {
              this.$message({
                message: this.$t('message.Operation_succeeded'),
                type: 'success'
              });
              let tab = {}
              tab.name = "appliance"
              this.handleTabChange(tab)
            }
            else {
              this.$message({
                message: this.$t('message.Operation_failed'),
                type: 'error'
              });
            }
          })
          .catch(error => {
            this.$message({
              message: this.$t('message.Operation_failed'),
              type: 'error'
            });
          })
      },
      editProcess(row){
        sessionStorage.removeItem('Data_History')
        sessionStorage.removeItem('tableDataCommercial')
        sessionStorage.removeItem('Data_Map')
        sessionStorage.removeItem('Data_Information')
        sessionStorage.removeItem('Data_Options')
        
        let api_url = _global.serverSrc + '/get_process_detail/';
        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        obj.reference_id = row.id
        this.$axios.post(api_url, obj)
        .then(response => {

        if (response.data.user_operation_history != null) {
            let data = JSON.parse(response.data.user_operation_history[0].report_param)
            if (response.data.process_detail != null) {
            let data = response.data.process_detail
            let lang = JSON.parse(sessionStorage.getItem("lang"));
            let user = JSON.parse(sessionStorage.getItem("User"));
            let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
            sessionStorage.clear();
            sessionStorage.setItem("lang", JSON.stringify(lang));
            sessionStorage.setItem("User", JSON.stringify(user));
            sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
            sessionStorage.setItem('Data_History', JSON.stringify(data))
            sessionStorage.setItem('Data_Map', JSON.stringify(data.data_map))
            this.createDataInformationFromHistory(data)
            sessionStorage.setItem('Data_Options', JSON.stringify(data.options))
            this.$router.push({
              path: '/map',
              query: {
                chosen_city: data.city
              }
            })
          }}}
        )

      },
      handleUpload(file) {

        this.client_logo_image = file.raw
        let FR = new FileReader();
        FR.readAsDataURL(this.client_logo_image);

        FR.onload = () => {
          this.client_logo_image = FR.result
        }
      },
      handleEdit(index, row) {        
        sessionStorage.removeItem('Data_History')
        sessionStorage.removeItem('tableDataCommercial')
        sessionStorage.removeItem('Data_Map')
        sessionStorage.removeItem('Data_Information')
        sessionStorage.removeItem('Data_Options')
        
        let api_url = _global.serverSrc + '/user_operation_history/?format=json';
        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        obj.id = row.id
        if(row.city.includes(",")){
          this.$axios.post(_global.serverSrc + '/user_operation_history_crosscity/?format=json', obj)
          .then(response => {
             this.$axios.post(_global.serverSrc + '/user_operation_history_crosscity/?format=json', obj)
          .then(response => {
           
            var param_json = JSON.parse(response.data.user_operation_history[0].report_param.replaceAll(`'`, `"`))
            let obj = {};
            var city=row.city.slice(0,row.city.length-1);
            var selectedCities =city.split(",");           
            let summaryTable = []
            let selectedMultiProposal = []
            
            summaryTable[0]={'city':'Nanjing','name':'Nanjing','line_qty': 0,'bus_line':[], 'body_qty': 0, 'impression': 0, 'impression_cluster': 0, 'price': 0,'cpm':0,'cpm_cluster':0,'data_audience':'','param_json':{'ifShowViewed':0}}
            summaryTable[1]={'city':'Wuhan','name':'Wuhan','line_qty': 0,'bus_line':[], 'body_qty': 0, 'impression': 0, 'impression_cluster': 0, 'price': 0,'cpm':0,'cpm_cluster':0,'data_audience':'','param_json':{'ifShowViewed':0}}
            summaryTable[2]={'city':'Shenzhen','name':'Shenzhen','line_qty': 0, 'bus_line':[],'body_qty': 0, 'impression': 0, 'impression_cluster': 0, 'price': 0,'cpm':0,'cpm_cluster':0,'data_audience':'','param_json':{'ifShowViewed':0}}
            summaryTable[3]={'city':'Chongqing','name':'Chongqing','line_qty': 0, 'body_qty': 0, 'bus_line':[],'impression': 0, 'impression_cluster': 0, 'price': 0,'cpm':0,'cpm_cluster':0,'data_audience':'','param_json':{'ifShowViewed':0}}
            summaryTable[4]={'city':'Chengdu','name':'Chengdu','line_qty': 0, 'body_qty': 0, 'bus_line':[],'impression': 0, 'impression_cluster': 0, 'price': 0,'cpm':0,'cpm_cluster':0,'data_audience':'','param_json':{'ifShowViewed':0}}
            
            param_json.forEach((item, index) => {
              let data = {}
              data.param_json = item;
              data.city = item.city
              data.body_qty = item.bus_body_qty
              data.bus_line = item.bus_line
              data.data_audience = item.data_audience
              data.data_audience.value_gender = this.changeDataToText(item.data_audience.value_gender, item.options.audience_options.gender_options)
              data.data_audience.value_age = this.changeDataToText(item.data_audience.value_age, item.options.audience_options.age_options)
              data.data_audience.value_spend_power = this.changeDataToText(item.data_audience.value_spend_power, item.options.audience_options.spend_power_options)
              data.data_audience.value_interest = this.changeDataToText(item.data_audience.value_interest, item.options.audience_options.interest_options)
              data.data_media = this.changeDataToText(item.data_media, item.options.media_rank_options.media_format_options)
              data.data_poi_ba_label_selection_list = this.changeDataToText_PoiSearch(item.poi_ba_label_selection_list)
              data.data_poi = this.changeDataToText_poi(item.data_poi)
              data.date =  new Date(item.date*1000).toISOString().split('T')[0]
              data.duration = item.duration
              data.impression = item.viewed_impression
              data.impression_cluster = item.viewed_impression_cluster
              data.line_qty = item.bus_line_qty
              data.name = item.city
              data.createdBy = item.created_by
              data.id = item.id
              if (item.data_map != ''){
                data.price = Number(item.data_map.proposal_discount_cost)
                data.cpm = (data.price/item.viewed_impression*1000).toFixed(2)
                data.cpm_cluster = (data.price/item.viewed_impression_cluster*1000).toFixed(2)
              } else {
                data.price = item.estimated_cost
                data.cpm = item.CPM
                data.cpm_cluster = item.CPM_cluster
               
              }  
              selectedMultiProposal.push(data)

              
            

            })
            
            for(let ele of selectedMultiProposal) {
             
        
              if(ele.city == 'Nanjing') {
                summaryTable[0].impression =  Number(summaryTable[0].impression) + Number(ele.param_json.viewed_impression)          
                summaryTable[0].impression_cluster =  Number(summaryTable[0].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
                summaryTable[0].price = Number(summaryTable[0].price) + Number(ele.param_json.price)
                summaryTable[0].cpm =  (summaryTable[0].price/summaryTable[0].impression*1000).toFixed(2)
                summaryTable[0].cpm_cluster = (summaryTable[0].price/summaryTable[0].impression_cluster*1000).toFixed(2)
                summaryTable[0].bus_line = this.MergeArrayAndFilter(summaryTable[0].bus_line,ele.bus_line)
                summaryTable[0].line_qty = summaryTable[0].bus_line.length
                summaryTable[0].body_qty = summaryTable[0].body_qty + ele.body_qty
                summaryTable[0].date = new Date(ele.param_json.date*1000).toISOString().split('T')[0]
                summaryTable[0].duration = ele.param_json.duration
                summaryTable[0].createdBy = ele.createdBy
                summaryTable[0].id = ele.param_json.id
              

              } else if (ele.city == 'Wuhan') {
                summaryTable[1].impression =  Number(summaryTable[1].impression) + Number(ele.param_json.viewed_impression)          
                summaryTable[1].impression_cluster =  Number(summaryTable[1].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
                summaryTable[1].price = Number(summaryTable[1].price) + Number(ele.param_json.price)
                summaryTable[1].cpm =  (summaryTable[1].price/summaryTable[1].impression*1000).toFixed(2)
                summaryTable[1].cpm_cluster = (summaryTable[1].price/summaryTable[1].impression_cluster*1000).toFixed(2)
                summaryTable[1].bus_line = this.MergeArrayAndFilter(summaryTable[1].bus_line,ele.bus_line)
                summaryTable[1].line_qty = summaryTable[1].bus_line.length
                summaryTable[1].body_qty = summaryTable[1].body_qty + ele.body_qty
                summaryTable[1].date = new Date(ele.param_json.date*1000).toISOString().split('T')[0]
                summaryTable[1].createdBy = ele.createdBy
                summaryTable[1].id = ele.param_json.id
                summaryTable[1].duration = ele.param_json.duration

              } else if (ele.city == 'Shenzhen') {
                summaryTable[2].impression =  Number(summaryTable[2].impression) + Number(ele.param_json.viewed_impression)          
                summaryTable[2].impression_cluster =  Number(summaryTable[2].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
                summaryTable[2].price = Number(summaryTable[2].price) + Number(ele.param_json.price)
                summaryTable[2].cpm =  (summaryTable[2].price/summaryTable[2].impression*1000).toFixed(2)
                summaryTable[2].cpm_cluster = (summaryTable[2].price/summaryTable[2].impression_cluster*1000).toFixed(2)
                summaryTable[2].bus_line = this.MergeArrayAndFilter(summaryTable[2].bus_line,ele.bus_line)
                summaryTable[2].line_qty = summaryTable[2].bus_line.length
                summaryTable[2].body_qty = summaryTable[2].body_qty + ele.body_qty
                summaryTable[2].date = new Date(ele.param_json.date*1000).toISOString().split('T')[0]
                summaryTable[2].createdBy = ele.createdBy
                summaryTable[2].id = ele.param_json.id
                summaryTable[2].duration = ele.param_json.duration


              } else if (ele.city == 'Chongqing'){
                summaryTable[3].impression =  Number(summaryTable[3].impression) + Number(ele.param_json.viewed_impression)          
                summaryTable[3].impression_cluster =  Number(summaryTable[3].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
                summaryTable[3].price = Number(summaryTable[3].price) + Number(ele.param_json.price)
                summaryTable[3].cpm =  (summaryTable[3].price/summaryTable[3].impression*1000).toFixed(2)
                summaryTable[3].cpm_cluster = (summaryTable[3].price/summaryTable[3].impression_cluster*1000).toFixed(2)
                summaryTable[3].bus_line = this.MergeArrayAndFilter(summaryTable[3].bus_line,ele.bus_line)
                summaryTable[3].line_qty = summaryTable[3].bus_line.length
                summaryTable[3].body_qty = summaryTable[3].body_qty + ele.body_qty
                summaryTable[3].date = new Date(ele.param_json.date*1000).toISOString().split('T')[0]
                summaryTable[3].createdBy = ele.createdBy
                summaryTable[3].id = ele.param_json.id
                summaryTable[3].duration = ele.param_json.duration

              } else if(ele.city == 'Chengdu') {
                summaryTable[4].impression =  Number(summaryTable[4].impression) + Number(ele.param_json.viewed_impression)          
                summaryTable[4].impression_cluster =  Number(summaryTable[4].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
                summaryTable[4].price = Number(summaryTable[4].price) + Number(ele.param_json.price)
                summaryTable[4].cpm =  (summaryTable[4].price/summaryTable[4].impression*1000).toFixed(2)
                summaryTable[4].cpm_cluster = (summaryTable[4].price/summaryTable[4].impression_cluster*1000).toFixed(2)
                summaryTable[4].bus_line = this.MergeArrayAndFilter(summaryTable[4].bus_line,ele.bus_line)
                summaryTable[4].line_qty = summaryTable[4].bus_line.length
                summaryTable[4].body_qty = summaryTable[4].body_qty + ele.body_qty
                summaryTable[4].date = new Date(ele.param_json.date*1000).toISOString().split('T')[0]
                summaryTable[4].createdBy = ele.createdBy
                summaryTable[4].id = ele.param_json.id
                summaryTable[4].duration = ele.param_json.duration
              }
            }
            summaryTable = this.summaryTableInfo(summaryTable)
            obj.selectedCities = {...selectedCities}
            obj.selectedProposals = {}
            obj.proposalClientName = row.clientName
            obj.selectedProposals.summaryTable = summaryTable
            obj.selectedMultProposal = selectedMultiProposal
            sessionStorage.setItem("Cross_city", JSON.stringify(obj));
   
            this.$router.push({
              path: "/cross_city_board",
              query: {
                cities : selectedCities
              }
            });
        })
        })
   
           
        } else {
           this.$axios.post(api_url, obj)
            .then(response => {
              if (response.data.user_operation_history != null) {
                  let data = JSON.parse(response.data.user_operation_history[0].report_param)
                  let lang = JSON.parse(sessionStorage.getItem("lang"));
                  let user = JSON.parse(sessionStorage.getItem("User"));
                  let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
                  sessionStorage.clear();
                  sessionStorage.setItem("lang", JSON.stringify(lang));
                  sessionStorage.setItem("User", JSON.stringify(user));
                  sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
                  sessionStorage.setItem('Data_History', JSON.stringify(data))
                  sessionStorage.setItem('Data_Map', JSON.stringify(data.data_map))
                  this.createDataInformationFromHistory(data)
                  sessionStorage.setItem('Data_Options', JSON.stringify(data.options))
                  this.$router.push({
                    path: '/map',
                    query: {
                      chosen_city: data.city
                    }
                  })
                }
              })
            .catch(e => {
            })
          }
       
      },
      summaryTableInfo(summaryTable) {
        let obj = {
                    "body_qty": 0,
                    "cpm": 0,
                    'cpm_cluster': 0,
                    'impression': 0,
                    'impression_cluster': 0,
                    'line_qty': 0,
                    'name': "summary",
                    'price': 0,
        }
        summaryTable.forEach((item, index) => {
          obj.body_qty=obj.body_qty + item.body_qty         
          obj.impression=obj.impression + item.impression
          obj.impression_cluster=obj.impression_cluster + item.impression_cluster
          obj.line_qty=obj.line_qty + item.line_qty
          obj.price=obj.price + item.price
        })
        obj.cpm = (obj.price/obj.impression*1000).toFixed(2)
        obj.cpm_cluster = (obj.price/obj.impression_cluster*1000).toFixed(2)
        summaryTable.push(obj)
        return summaryTable
      },
      changeDataToText_poi(poi) {
      let str = "";
      if (poi.checked_business == true) {
        str = str + this.$t('message.BUSINESS') + ' ';
      }
      if (poi.checked_entertainment == true) {
        str = str + this.$t('message.ENTERTAINEMENT') + ' ';
      }
      if (poi.checked_living == true) {
        str = str + this.$t('message.LIVING') + ' ';
      }
      if (poi.checked_trip == true) {
        str = str + this.$t('message.TRIP');
      }
      return str;
    },

      changeDataToText(data, options) {
        let obj = "";
        if (this.$i18n.locale == 'en'){
          if (typeof(data) == "number") {
            for (let i = 0; i < options.length; i++) {
              if (Number(options[i].value) == data) {
                obj = obj + options[i].label;
              }
            }
          } else if (typeof(data) == "object") {
            if (data.length > 1) {
              data = data.sort();
            }
        
            for (let d in data) {
              for (let op in options) {
                if (Number(data[d]) == Number(options[op].value)) {
                  obj = obj + String(options[op].label) + ' ';
                }
              }
            }
          } 
        } else if (this.$i18n.locale == 'cn'){
          if (typeof(data) == "number") {
            for (let i = 0; i < options.length; i++) {
              if (Number(options[i].value) == data) {
                obj = obj + options[i].label_cn;
              }
           }
          } else if (typeof(data) == "object") {
            if (data.length > 1) {
              data = data.sort();
            }
        
            for (let d in data) {
              for (let op in options) {
                if (Number(data[d]) == Number(options[op].value)) {
                  obj = obj + String(options[op].label_cn) + ' ';
               }
              }
           }
          }
        }      
        return obj;
      },

      changeDataToText_PoiSearch(poi_ba_label_selection_list){
        let poi_ba_label_selection_list_text = ''
        for (let index in poi_ba_label_selection_list){
          poi_ba_label_selection_list_text = poi_ba_label_selection_list_text + poi_ba_label_selection_list[index] + ' '
        }
        return poi_ba_label_selection_list_text
      },

      createDataInformationFromHistory(dataHistory){
        let obj={}
        obj.data_audience=dataHistory.data_audience
        obj.data_poi = this.changeBooleanInverse(dataHistory.data_poi)
        let obj2={}
        obj2.value_media_format = dataHistory.data_media
        obj2.value_rank = dataHistory.data_rank
        obj.data_media_rank = obj2
        obj.date = new Date(Number(dataHistory.date)*1000).toISOString()
        obj.value_duration = dataHistory.duration
        obj.isEdit = 1
        sessionStorage.setItem('Data_Information', JSON.stringify(obj))
      },
      
      changeBooleanInverse(data_poi){
        if (data_poi == 0){
          data_poi = false
        } else if (data_poi == 1){
          data_poi = true
        }else{
          for (let ele in data_poi){
            if (data_poi[ele] == 1){
              data_poi[ele] = true
            }else{
              data_poi[ele] = false
            }
          }
        }
        return data_poi
      },
      handleDelete(index, row) {
      },
      goHome: function(event) {
        this.$router.push({
          path: '/choose_city'
        });
        let lang = JSON.parse(sessionStorage.getItem("lang"));
        let user = JSON.parse(sessionStorage.getItem("User"));
        let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
        sessionStorage.clear();
        sessionStorage.setItem("lang", JSON.stringify(lang));
        sessionStorage.setItem("User", JSON.stringify(user));
        sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
      },
      backToLogin: function(event) {
        this.$router.push({
          path: '/',
        });
      },
      updateStatusOption: function(){
        this.status_options[0].label = this.$t('message.Draft')
        this.status_options[1].label = this.$t('message.Discussion')
        this.status_options[2].label = this.$t('message.Sent')
        this.status_options[3].label = this.$t('message.Win')
        this.status_options[4].label = this.$t('message.Fail')
        this.status_options[5].label = this.$t('message.Cancelled')
        //this.status_options[6].label = this.$t('message.Archive')
      },
      proposalStatusChange: function(val){
        this.updateStatusOption();
        for(let ele in this.status_options){
          if (this.status_options[ele].value == val){
            return this.status_options[ele].label
          }
        }
      },
      inverseProposalStatusChange: function(val){
        for(let ele in this.status_options){
          if (this.status_options[ele].label == val){
            return this.status_options[ele].value
          }
        }
      },
      updateProcessStatusOption() {
        this.process_status_options[0].label = this.$t('message.Pending')
        this.process_status_options[1].label = this.$t('message.Cancelled')
        this.process_status_options[2].label = this.$t('message.Approved_by_Director')
        this.process_status_options[3].label = this.$t('message.Changed_by_Director')
        this.process_status_options[4].label = this.$t('message.Refused_by_Director')
        this.process_status_options[5].label = this.$t('message.Accepted')
        this.process_status_options[6].label = this.$t('message.Refused')
      },
      processStatusChange: function(val){
        this.updateProcessStatusOption();
        for(let ele in this.process_status_options){
          if (this.process_status_options[ele].value == val){
            return this.process_status_options[ele].label
          }
        }
      },
      getHistoryData: function(data) {
        let api_url = _global.serverSrc + '/user_history/?format=json';
        let obj = {}
        obj.currentPage = this.currentPage
        obj.pageSize = this.pageSize
        obj.clientKeyword = this.clientKeyword
        obj.creatorKeyword = this.creatorKeyword
        obj.statusArray = this.statusArray
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data != null) {
              this.totalSize = response.data.total_size
              this.tableData=[]
              for (let ele of response.data.user_history) {
                let tmp = {}
                tmp.id = ele.reference_id
                tmp.createdAt = ele.created_at
                tmp.city = ele.city
                tmp.clientName = ele.client_name
                tmp.campaignStart = ele.campaign_start
                tmp.campaignEnd = ele.campaign_end
                tmp.createdBy = ele.created_by
                tmp.impressions = Number(ele.viewed_impression).toLocaleString()
                tmp.total_media_budget = Number(ele.estimated_cost).toLocaleString()
                tmp.total_bus_line = Number(ele.number_bus)
                tmp.team = ele.bu_city
                tmp.status = this.proposalStatusChange(ele.proposal_status)
                tmp.isChanged = false
                tmp.status_options = this.createSelfOption(ele.proposal_status)
                tmp.package_id = ele.package_id
                tmp.package_name = ele.package_name
                tmp.proposal_status = ele.proposal_status
                tmp.is_shared = (ele.is_shared==1)
                this.tableData.push(tmp)
              }
            }
          })
          .catch(e => {
          })
      },
      getProcessData() {
        let api_url = _global.serverSrc + '/get_process_list/?format=json';
        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data != null) {
              this.processTableData=[]
              for (let ele of response.data.process_history) {
                let tmp = {}
                tmp.id = ele.reference_id
                tmp.createdAt = ele.created_at
                tmp.createdBy = ele.created_by
                tmp.updatedAt = ele.updated_at
                tmp.updatedBy = ele.updated_by
                tmp.city = ele.city
                tmp.clientName = ele.client_name
                tmp.comment_sd = ele.comment_sd
                tmp.comment_mo = ele.comment_mo
                tmp.campaignStart = ele.campaign_start
                tmp.campaignEnd = ele.campaign_end
                tmp.createdBy = ele.created_by
                tmp.impressions = Number(ele.viewed_impression).toLocaleString()
                tmp.total_media_budget = Number(ele.estimated_cost).toLocaleString()
                tmp.total_bus_line = Number(ele.number_bus)
                tmp.team = ele.bu_city
                tmp.status = this.processStatusChange(ele.process_status)
                tmp.process_type = ele.process_type
                tmp.isChanged = false
                tmp.package_id = ele.package_id
                tmp.package_name = ele.package_name
                tmp.process_status = ele.process_status
                tmp.updated_at_mo = ele.updated_at_mo
                tmp.updated_by_mo = ele.updated_by_mo
                tmp.updated_at_sd = ele.updated_at_sd
                tmp.updated_by_sd = ele.updated_by_sd
                tmp.email = ele.email
                this.processTableData.push(tmp)
              }
            }
          })
          .catch(e => {
          })
      },
      createSelfOption: function(status_code){
        let options = [...this.status_options]
        switch (status_code) {
          case 7: //Archive
                  options = options.filter(option=>{
                    return ["1","7"].includes(option.value)
                  })
                  break;
          case 6: //Cancelled
                  options = options.filter(option=>{
                    return ["1","6"].includes(option.value)
                  })
                  break;
          case 5: //fail
                  options = options.filter(option=>{
                    return option.value == "5"
                  })
                  break;
          case 4: //win
                  options = options.filter(option=>{
                    return option.value == "4"
                  })
                  break;
          case 3: //sent
                  options = options.filter(option=>{
                    return ["2","3"].includes(option.value)
                  })
                  break;
          case 2: //discussion
                  options = options.filter(option=>{
                    return !["1","6"].includes(option.value)
                  })
                  break;
          case 1: //draft
                  options = options.filter(option=>{
                    return ["2","3","6","7"].includes(option.value)
                  })
                  break;
          default:
            break;
        }

        return options
      },
      //用了vuex后改，原函数在information.vue
      setDataFromDB_media_info(_self, arr, lang) {
        if (lang == "cn") {
          for (let ele in arr) {
            if (arr[ele].content == "media format") {
              _self.media_format_options.push({
                value: arr[ele].code,
                label: arr[ele].label_cn
              });
            } else if (arr[ele].content == "rank") {
              _self.rank_options.push({
                value: arr[ele].code,
                label: arr[ele].label_cn
              });
            }
          }
        } else {
          for (let ele in arr) {
            if (arr[ele].content == "media format") {
              _self.media_format_options.push({
                value: arr[ele].code,
                label: arr[ele].label
              });
            } else if (arr[ele].content == "rank") {
              _self.rank_options.push({
                value: arr[ele].code,
                label: arr[ele].label
              });
            }
          }
        }
      
      
      },
      getMediaInfo(data) {
        let api_url = _global.serverSrc + '/media_info/';
        let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
        var _self = this;
        this.$axios.get(api_url, obj)
          .then(response => {
            if (response.data) {
              _self.setDataFromDB_media_info(_self, response.data.media_info, _self.$i18n.locale)
            }
          })
          .catch(function(error) {
          });
      },
      sortOptionsByValue: function(options) {
        var i = options.length,
          j;
        var tempExchangVal;
        while (i > 0) {
          for (j = 0; j < i - 1; j++) {
            if (options[j].value > options[j + 1].value) {
              tempExchangVal = options[j];
              options[j] = options[j + 1];
              options[j + 1] = tempExchangVal;
            }
          }
          i--;
        }
      },
      setDataFromDB_audience_info(_self, arr, lang) {
        if (lang == "cn") {
          for (let ele in arr) {
            if (_self.audience_info[ele].content == "gender") {
              _self.gender_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label_cn
              });
            } else if (_self.audience_info[ele].content == "age") {
              _self.age_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label_cn
              });
            } else if (_self.audience_info[ele].content == "spend power") {
              _self.spend_power_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label_cn
              });
            } else if (_self.audience_info[ele].content == "interest") {
              _self.interest_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label_cn
              });
            }
      
          }
        } else {
          for (let ele in arr) {
            if (_self.audience_info[ele].content == "gender") {
              _self.gender_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label
              });
            } else if (_self.audience_info[ele].content == "age") {
              _self.age_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label
              });
            } else if (_self.audience_info[ele].content == "spend power") {
              _self.spend_power_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label
              });
            } else if (_self.audience_info[ele].content == "interest") {
              _self.interest_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label
              });
            }
      
          }
        }
      
      },
      async getAudienceInfo() {
        let api_url = _global.serverSrc + '/audience_info/';
        let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
        var _self = this;
        await this.$axios.post(api_url, obj)
          .then(function(response) {
            if (response.data) {
              _self.audience_info = response.data.audience_info;
              //初始化
              _self.gender_options = [];
              _self.age_options = [];
              _self.spend_power_options = [];
              _self.interest_options = [];
      
              _self.setDataFromDB_audience_info(_self, _self.audience_info, _self.$i18n.locale);
              _self.sortOptionsByValue(_self.gender_options);
              _self.sortOptionsByValue(_self.age_options);
              _self.sortOptionsByValue(_self.spend_power_options);
              _self.sortOptionsByValue(_self.interest_options);
            }
          })
          .catch(function(error) {
          });
      },
      getUserOptionList() {
        let api_url = _global.serverSrc + '/get_user_list/';
        let obj = new Object();
        // obj.user_role = ['NationalSales', 'NationalSalesTeamHead','NationalSalesDirector','ShenzhenNationalSales','ShenzhenNationalSalesTeamHead','ShenzhenNationalDirector']
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            this.user_options = response.data.user_list
          })
          .catch(error => {
          })
      },
      tableRowClassName({row,rowIndex}) {
        if(row.package_id && row.package_id != '') {
          return 'package-source-row'
        }else{
          return ''
        }
      },
      rowClass({ rowIndex, columnIndex }) {
      if (rowIndex === 0) {       
          return {background:'#254A6E',color:'white'}
      }
    },
      processRowClassName({row,rowIndex}) {
        return ''
      },
      share(row) {
        this.selectedProposal = row
        this.shareFormVisible = true
      },
      handleCloseDialog() {
        this.shareFormVisible = false;
        this.selectedUser = '';
      },
      handleConfirmDialog() {
        let api_url = _global.serverSrc + '/insert_shared_proposal/';
        let obj = new Object();
        obj.from_user_id = JSON.parse(sessionStorage.getItem("UserAuthority")).user_id
        obj.to_user_id = this.selectedUser.user_id
        obj.proposal_reference_id = this.selectedProposal.id
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.status_check && response.data.status_check[0].status == "insert_success") {
              this.shareSuccessNotify();
            }
            else if (response.data.status_check && response.data.status_check[0].status == "proposal_exist") {
              this.shareWarningNotify();
            } else {
              this.shareErrorNotify();
            }
            this.selectedUser = '';
          })
          .catch(error => {
            this.shareErrorNotify();
            this.selectedUser = '';
          })
        
        this.shareFormVisible = false;
      },
      shareSuccessNotify() {
        this.$notify({
          title: this.$t('message.Success'),
          message: this.$t('message.Share_with_success'),
          type: 'success',
          duration: 2000
        });
      },
      shareWarningNotify() {
        this.$notify({
          title: this.$t('message.Warning'),
          message: this.$t('message.This_proposal_has_been_already_shared_with_user').replace('$user', this.selectedUser.user_name),
          type: 'warning',
          duration: 2000
        });
      },
      shareErrorNotify() {
        this.$notify.error({
          title: this.$t('message.Error'),
          message: this.$t('message.Fail_to_share'),
          duration: 2000
        });
      },
      handleSizeChange(val) {
        this.currentPage = this.currentPage*this.pageSize/val + this.currentPage*this.pageSize%val==0 ? 0:1
        this.pageSize = val;
        this.getHistoryData()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getHistoryData()
      },
      clientFilterHandler() {
        this.clientKeywordVisible = false;
        this.currentPage = 1
        this.clientKeywordHighlight = true;
        this.getHistoryData()
      },
      clientResetHandler() {
        this.clientKeywordVisible = false;
        this.clientKeyword = ""
        this.currentPage = 1
        this.clientKeywordHighlight = false;
        this.getHistoryData()
      },
      creatorFilterHandler() {
        this.creatorKeywordVisible = false;
        this.currentPage = 1
        this.creatorKeywordHighlight = true;
        this.getHistoryData()
      },
      creatorResetHandler() {
        this.creatorKeywordVisible = false;
        this.creatorKeyword = ""
        this.currentPage = 1
        this.creatorKeywordHighlight = false;
        this.getHistoryData()
      },
      statusFilterHandler() {
        this.statusArrayVisible = false;
        this.currentPage = 1
        this.statusArrayHighlight = true;
        this.getHistoryData()
      },
      statusResetHandler() {
        this.statusArrayVisible = false;
        this.statusArray = []
        this.currentPage = 1
        this.statusArrayHighlight = false;
        this.getHistoryData()
      },
      getRowKeys(row) {
        return row.id
      },
      expandSelect(row, expandedRows) {
      },
      expendProcess(row, expandedRows) {
        if (!row.process_detail) {
          row.loading = true
          let api_url = _global.serverSrc + '/get_process_detail/';
          let obj = new Object();
          obj.email = JSON.parse(sessionStorage.getItem('User'))
          obj.reference_id = row.id
          this.$axios.post(api_url, obj)
            .then(response => {
              row.process_detail = response.data.process_detail
              row.loading = false
              this.processTableData = [...this.processTableData]
            })
            .catch(error => {
            })
        }
      },
      handleTabChange(tab, event) {
        if (tab.name == "proposal") {
          this.loading = true
          this.getHistoryData()
          this.share_proposal = JSON.parse(sessionStorage.getItem("UserAuthority")).share_proposal
          this.getUserOptionList()
          this.loading = false
        }
        else if (tab.name == "appliance") {
          this.loading = true
          this.getProcessData()
          this.loading = false
        }
      },
      enableReviewProcess(row) {
        return (row.process_status == 1 && JSON.parse(sessionStorage.getItem("UserAuthority")).role == "SalesDirector") || (row.process_status ==  4 && row.email == JSON.parse(sessionStorage.getItem("User")))
      },
      enableCancelProcess(row) {
        return row.process_status ==  1 && row.email == JSON.parse(sessionStorage.getItem("User"))
      },
      enableEditProcess(row) {
        return (row.process_status ==  2 || row.process_status == 5 || row.process_status == 7) && row.email == JSON.parse(sessionStorage.getItem("User"))
      },
      getStatusSd(status) {
        if (status == 2)
          return ''
        else {
          status = (status == 6 || status == 7) ? 4 : status
          return this.process_status_options[status-1].label
        }
      },
      getStatusSales(status) {
        if (status < 6 && status !=2 )
          return ''
        else {
          return this.process_status_options[status-1].label
        }
      },
      isMediaPricingMode(row) {
        return row.process_detail.data_map.pricingMode == "media"
      },
    },
    watch: {
      localLang() {
        for (let ele of this.tableData) {
          ele.status = this.proposalStatusChange(ele.proposal_status)
          ele.status_options = this.createSelfOption(ele.proposal_status)
        }
        for (let ele of this.processTableData) {
          ele.status = this.processStatusChange(ele.process_status)
        }
      }
    }
  }
</script>

<style lang="scss">
  .proposal-history-table-filter {
    margin: -12px;

    .proposal-history-table-filter__content{
      padding: 10px 10px 0 10px;

      .sub-title {
        margin: 5px;
        line-height: 19px;
        font-size: 14px;
      }
      
      .search-input {
        margin: 5px;
        -webkit-appearance: none;
        background-color: #FFFFFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: none;
        padding: 0 15px;
        -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 200px;
      }

      input::-webkit-input-placeholder {
        color: #DCDFE6;
      }

      .el-checkbox {
        display: block;
        margin: 0 0 10px 10px;

        .el-checkbox__label {
          margin: 0 5px;
        }
      }
    }

    .proposal-history-table-filter__bottom {
      border-top: 1px solid #EBEEF5;
      padding: 13px;

      button {
        background: transparent;
        border: none;
        color: #606266;
        cursor: pointer;
        font-size: 13px;
        padding: 0 3px;

        
      }

      button.is-disabled {
        color: #C0C4CC;
        cursor: not-allowed;
      }
    }    
  }
</style>

<style lang="scss" scoped>
  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 200px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }

  .circle{
    border-radius: 100%;
    margin: 0.65em 0 0 8em;
    padding:4px;
    width: 8px;
    height: 8px;
  }
  .gray{
    background-color:#95989be7;
  }
  .win{
    background-color: rgb(78,185,175)
  }
  .discussion{
    background-color: #c3c5c7ad;
  }
  .el-table /deep/ th, .el-table /deep/ td {
    @media (max-width:767px) {
      padding: 10px 0;
      font-size: 10px;
    }
  }
  .el-table /deep/ .el-input__inner {
    @media (max-width:767px) {
      font-size: 10px;
      padding-left: 9px;
    }
  }

  .el-table /deep/ .el-button {
    @media (max-width:767px) {
      font-size: 10px;
    }
  }

  .demo-table-expand /deep/ .el-form-item__label {
    @media (max-width:767px) {
      font-size: 10px;
      line-height: 20px;
      font-weight: 600;
    }
  }
  
  .demo-table-expand /deep/ .el-form-item__content {
    @media (max-width:767px) {
      font-size: 10px;
      line-height: 20px;
    }
  }

  .demo-table-expand /deep/ label {
    @media (max-width:767px) {
      margin: 0;
    }
  }

  /deep/ .el-divider--horizontal {
    @media (max-width:767px) {
      margin: 5px 0;
    }
  }

  .el-dialog__wrapper /deep/ .el-dialog {
    max-width: 480px;
    @media (max-width:767px) {
      width: 90%;
    }
    
    @media (min-width:768px) and (max-width:1199px) {
      width: 40%;
    }

    @media (min-width:1200px) {
      width: 25%;
    }
  }

  span.highlight{
    color: #409EFF;
  }

  /deep/.el-table__column-filter-trigger i {
    font-weight: bold;
    font-size: 18px;
    color: BLUE;
  }

  .el-icon-arrow-down {
    font-weight: bold;
    font-size: 18px;
    color: BLUE;
  }

  /deep/ .el-tabs__header {
    margin: 15px 0 0;
  }

  /deep/ .el-card__body {
    padding: 10px;
  }

  /deep/ .el-card__header {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .process_next_icon {
    text-align: center;
    font-size: 40px;
    margin-top: 60px;
  }

  /deep/ .el-descriptions__body td {
    width: 50%
  }

</style>